import styled from '@emotion/styled';
import Image from 'presentations/views/components/atoms/Image';
import { fontSize, fontWeight, spacing } from 'presentations/views/styles';
import { gray01 } from 'presentations/views/styles/color';

type Props = {
  imageUrl: string;
  name: string;
  email: string;
};

export default function Component(props: Props) {
  return (
    <StyledContainer>
      <StyledImage src={props.imageUrl} alt={props.name} />
      <StyledContent>
        <StyledName>{props.name}</StyledName>
        {props.email && <StyledEmail>{props.email}</StyledEmail>}
      </StyledContent>
    </StyledContainer>
  );
}

const StyledContainer = styled.div`
  display: flex;
`;
const StyledImage = styled(Image)`
  width: 40px;
  height: 40px;
  border-radius: 50%;
`;
const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: ${spacing(12)};
`;
const StyledName = styled.div`
  font-size: ${fontSize(14)};
  font-weight: ${fontWeight('bold')};
`;
const StyledEmail = styled.div`
  font-size: ${fontSize(11)};
  color: ${gray01};
`;
